import {
  BOOK_FOLLOW,
  BOOK_UNFOLLOW,
  BOOKS_CREATE,
  BOOKS_FETCH,
  BOOKS_SHOW,
  BOOKS_FETCH_CATERERS,
  BOOKS_LIST_CLEAR,
  BOOKS_SEARCH
} from '../constants/booksTypes';

export function booksCreate(params) {
  return {
    type: BOOKS_CREATE,
    payload: params
  };
}

export function booksFetch(params) {
  return {
    type: BOOKS_FETCH,
    payload: params
  };
}

export function booksShow(params) {
  return {
    type: BOOKS_SHOW,
    payload: params
  };
}

export function booksListClear() {
  return {
    type: BOOKS_LIST_CLEAR
  };
}

export function booksFetchCaterers(params) {
  return {
    type: BOOKS_FETCH_CATERERS,
    payload: params
  };
}

export function bookFollow(params) {
  return {
    type: BOOK_FOLLOW,
    payload: params
  };
}

export function bookUnfollow(params) {
  return {
    type: BOOK_UNFOLLOW,
    payload: params
  };
}

export function searchBooks(query) {
  return {
    type: BOOKS_SEARCH,
    payload: { query }
  };
}



// WEBPACK FOOTER //
// ./app/actions/booksActions.js